// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1c20577e","160":"5a561b28","208":"545ace9b","293":"916ee3db","453":"169e475c","516":"940d7274","519":"d56a0db5","917":"9bb299c7","946":"fdd4e44f"}[chunkId] + ".chunk.js";
};